"use client";

import Image from "next/image";
import { cn } from "@/lib/utils";

interface AiNavIconProps {
	active: boolean;
	className?: string;
	activeClassName?: string;
	inactiveClassName?: string;
	label?: string;
}

export function AiNavIcon({
	active,
	className,
	activeClassName,
	inactiveClassName,
	label = "AI",
}: AiNavIconProps) {
	if (active) {
		return (
			<Image
				src="/ai.png"
				alt={label}
				width={20}
				height={20}
				className={cn("block size-5 shrink-0 object-contain", className, activeClassName)}
				loading="eager"
			/>
		);
	}

	return (
			<span
				aria-hidden="true"
				className={cn(
					"block size-5 shrink-0 bg-current",
					"[mask-image:url('/ai.png')]",
					"[mask-position:center]",
					"[mask-repeat:no-repeat]",
				"[mask-size:contain]",
				"[-webkit-mask-image:url('/ai.png')]",
				"[-webkit-mask-position:center]",
				"[-webkit-mask-repeat:no-repeat]",
				"[-webkit-mask-size:contain]",
				className,
				inactiveClassName,
			)}
		/>
	);
}
